export default __webpack_public_path__ + "static/media/swipe-up-down.74e71f84.svg";